import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {AirConfigService}  from 'src/app/services/air-config.service'
import {PaymentConfigService}  from 'src/app/services/payment-config.service'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { Router ,ActivatedRoute, NavigationEnd} from '@angular/router';
import {PaymentContractService}  from 'src/app/services/payment-contract.service'
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-payment-contract',
  templateUrl: './payment-contract.component.html',
  styleUrls: ['./payment-contract.component.css']
})
export class PaymentContractComponent {



  sharePopup = false;
  savePaymentFg!: FormGroup;
  paymentChannelList:any
  productdata:any=[]
  userUid:any
  constructor(private fb: FormBuilder,private AirConfigService:AirConfigService,private PaymentConfigService:PaymentConfigService,private toastmsgService:ToastmsgService,private router:Router,private route:ActivatedRoute,private PaymentContractService:PaymentContractService ) {
    let currentRoute:any;
    currentRoute = this.router?.routerState?.snapshot?.url;
    this.route.paramMap.subscribe(params => {
     let id= params.get('token');
     if(id){
      
      this.userUid=id
      this.list()
     }
    });
 
 
    this.paymentChannels()
this.ProductList()
this.payMode()
this.payChannel()
  }
  onlyNumberKey(event:any) {
     
    let charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
        && (charCode < 48 || charCode > 57))
        return false;
    return true;
  }
  ngOnInit(): void {
    this.savePaymentFg = this.fb.group({
      customerId: [this.userUid, Validators.required],
      product: ['AIR', Validators.required],
      supplierPayment: ['',Validators.required],
      platformPayment: ['', Validators.required],
      agentPayment: [''],
      platformPaymentCharges: ['',Validators.required],
      paymentChannel: ['',Validators.required],
      passthroughSuppliers: [''],
      paymentModes: ['',Validators.required]
    });
  }
openPop(){
  this.sharePopup=true
  this.blankData()
  this.action='new'

}
  
blankData(){
  this.savePaymentFg = this.fb.group({
    customerId: [this.userUid, Validators.required],
    product: ['AIR', Validators.required],
    supplierPayment: ['',Validators.required],
    platformPayment: ['', Validators.required],
    agentPayment: [''],
    platformPaymentCharges: ['',Validators.required],
    paymentChannel: ['',Validators.required],
    passthroughSuppliers: [''],
    paymentModes: ['',Validators.required]
  });
}



  columns: string[] = ['date', 'amount', 'status'];
  displayedColumns: string[] = [
    'contractId',
    // 'customerId',
    'product',
    // 'supplierPayment',
    // 'platformPayment',
    // 'agentPayment',
    // 'status',
   
    // 'platformPaymentCharges',
    'paymentChannel',
    // 'passthroughSuppliers',
    'paymentModes',
    'creationTS',
    'modTS',
  ];
  upcomingPayments = [
    // { date: 'March 15, 2024', amount: '$50.00', status: 'Pending' },
    // { date: 'April 15, 2024', amount: '$50.00', status: 'Scheduled' },
    // { date: 'May 15, 2024', amount: '$50.00', status: 'Scheduled' }
  ];

  paymentHistory = [
    // { date: 'February 15, 2024', amount: '$50.00', status: 'Paid' },
    // { date: 'January 15, 2024', amount: '$50.00', status: 'Paid' },
    // { date: 'December 15, 2023', amount: '$50.00', status: 'Paid' }
  ];
  
  paymentChannels(){

    this.AirConfigService
    .getPaymentChannels()
    .subscribe({
      next : (res:any) => {
        if(res) {
       let data=res
       this.paymentChannelList=data
       
        } else {
        
        } 
      },error : (err) => {
  
      }
    }
  )
  }

  ProductList(){

    this.PaymentConfigService
    .productList()
    .subscribe({
      next : (res:any) => {
        if(res) {
       let data=res
       this.productdata=data
       
        } else {
        
        } 
      },error : (err) => {

      }
    }
  )
  }
disabled:boolean=false
  onSavePayment(status:any) {
    if (this.savePaymentFg.valid) {
      this.disabled=true
      const formData = this.savePaymentFg.value;
     this.AddCreditCard(status)
    }
  }
  AddCreditCard(status:any){
    
    this.PaymentContractService.save(this.savePaymentFg.value)
    .subscribe({
      next : (res) => {
        this.disabled=false
        if(res.status==200 ) {
          if(status==='new'){
            this.toastmsgService.setMsg({msg : "Payment Contract Added Successfully!",msgTitle : "Success", msgType : "I"});

          }else{
            this.toastmsgService.setMsg({msg : "Payment Contract Updated Successfully!",msgTitle : "Success", msgType : "I"});

          }
         
          this.sharePopup = false; // Close the popup
        this.list()
        } else {
          const body : any = res.body;
          this.registerPaymentErrorMsg(res.status,body?.result,status);
        } 

      },error : (err) => {
        this.disabled=false

        this.registerPaymentErrorMsg(err.status,err.error,status);
      }
    }
  )

}

registerPaymentErrorMsg(status : number,msg : string,stat:any) {
  
  if(stat==='new') {
    this.toastmsgService.setMsg({msg : "Failed to save Payment Contract",msgTitle : "Warning", msgType : "W"});
  } else {

    this.toastmsgService.setMsg({msg : "Failed to Update Payment Contract",msgTitle:  "Warning", msgType : "W"});
  } 
}
list(){
    this.PaymentContractService.list(this.userUid)
    .subscribe({
      next : (res:any) => {
        if(res) {
         let data:any
         data=res  

         this.upcomingPayments=data
  
       
        } else {    
        } 
      },error : (err) => {
        
  
  
      }
    }
  )
  }
  formatDate(val: Date) {
    let convertedValue:any = ""
    if(val){
    let datepipe = new DatePipe("en");
    //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
    convertedValue =  datepipe.transform(val, "dd-MM-yyyy hh:mm:ssa");
    }
    return convertedValue;
  }
  payModeList:any=[]
  payChannelList:any=[]
  payMode(){

    this.PaymentContractService
    .payMode()
    .subscribe({
      next : (res:any) => {
        if(res) {
       let data=res
       this.payModeList=data

        } else {
        
        } 
      },error : (err) => {

      }
    }
  )
  }
  payChannel(){

    this.PaymentContractService
    .payChannel()
    .subscribe({
      next : (res:any) => {
        if(res) {
       let data=res
       this.payChannelList=data
       
        } else {
        
        } 
      },error : (err) => {

      }
    }
  )
  }
  action:any
  rowClick(item:any){
this.action='update'
this.sharePopup = true; // Close the popup

this.savePaymentFg = this.fb.group({
  customerId: [this.userUid, Validators.required],
  product: [item?.product, Validators.required],
  supplierPayment: [item?.supplierPayment,Validators.required],
  platformPayment: [item?.platformPayment, Validators.required],
  agentPayment: [item?.agentPayment],
  platformPaymentCharges: [item?.platformPaymentCharges,Validators.required],
  paymentChannel: [item?.paymentChannel,Validators.required],
  passthroughSuppliers: [item?.passthroughSuppliers],
  paymentModes: [item?.paymentModes,Validators.required],
  contractId: [item?.contractId],

});

  }
  supplierPaymentChange(){
if(this.savePaymentFg.value.supplierPayment==='BUSINESS_BTA_CARD'||this.savePaymentFg.value.supplierPayment==='EMPLOYEE_CORPORATE_CARD'){
  this.paymentChannelList.paymentChannels=this.paymentChannelList?.paymentChannels.filter((item:any)=>item==='CARD')

}else{
  this.payMode()

}
  }
}
